import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** The action that resolves the emptiness — "clear filters", "add the first project". */
  action?: ReactNode;
  className?: string;
}

/**
 * What a list shows when it has nothing.
 *
 * Always says why it is empty and what to do about it. "No results" alone
 * leaves the visitor unsure whether the filter is too narrow or the site is
 * broken, and those two need different reactions.
 */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-lg',
        'border border-dashed border-border px-6 py-16 text-center',
        className,
      )}
    >
      {icon ? <div className="text-text-subtle">{icon}</div> : null}
      <p className="text-lg font-semibold text-text">{title}</p>
      {description ? <p className="max-w-prose text-sm text-text-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
